/**
 * Walkthrough copy quotes UI labels in straight double quotes ("Chart Queue").
 * Cards render each quoted label in bold WITHOUT the quotes; screen readers get
 * the same text without quotes or markup. Unpaired quotes are left as they are.
 * Copy strings stay unchanged — this is the one rendering rule.
 */
const PAIR = /"([^"\n]+)"/g

const escapeHtml = (s: string) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

/** Safe HTML for driver.js (innerHTML): escape first, then bold the quoted pairs. */
export function copyToHtml(text: string): string {
  return escapeHtml(text).replace(/&quot;((?:(?!&quot;).)+?)&quot;/g, '<strong>$1</strong>')
}

/** Plain text (live region, toasts): quoted pairs lose their quotes. */
export function copyToPlain(text: string): string {
  return text.replace(PAIR, '$1')
}

/** Segments for React rendering: `{ text, bold }` runs, in order. */
export function copySegments(text: string): { text: string; bold: boolean }[] {
  const out: { text: string; bold: boolean }[] = []
  let last = 0
  for (const m of text.matchAll(PAIR)) {
    if (m.index > last) out.push({ text: text.slice(last, m.index), bold: false })
    out.push({ text: m[1], bold: true })
    last = m.index + m[0].length
  }
  if (last < text.length) out.push({ text: text.slice(last), bold: false })
  return out
}
